<script lang="ts" setup>
import Toast from 'primevue/toast';
import { AppConfirmDialog } from '~/components/base';
import { AppTopbar } from '~/components/layout';
</script>

<template>
  <div class="split-layout relative h-screen w-full">
    <AppTopbar />
    <div class="split-layout__content flex h-full">
      <div class="split-layout__content__left flex-1 md:block" />
      <div
        class="split-layout__content__right flex flex-1 items-center justify-center"
      >
        <div
          class="split-layout__content__border split-page-size flex flex-1 items-center justify-center"
        >
          <NuxtPage :page-key="(route) => route.fullPath" class="flex-1" />
        </div>
      </div>
    </div>

    <Toast />
    <AppConfirmDialog />
  </div>
</template>

<style lang="scss" scoped>
.split-layout {
  margin-top: var(--header-height);
  max-height: calc(100vh - var(--header-height));

  &__content {
    &__left {
      background-image: url('~/assets/images/background.jpg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    &__right {
    }
  }
}
</style>
